/**
 * Copyright (C) Sitevision 2002-2024, all rights reserved
 */
import { hasPortlet } from '../util/findPortlets';

if (hasPortlet('sv-video-portlet')) {
  import(/*webpackChunkName: "video-portlet" */ './video.css');
}
